var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayBlue = function SvgPlayBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "M10.76 16.37c-.42 0-.81-.1-1.16-.3-.8-.46-1.26-1.4-1.26-2.59v-2.96c0-1.18.46-2.13 1.26-2.59s1.84-.39 2.87.21l2.57 1.48c1.02.59 1.61 1.46 1.61 2.38s-.59 1.79-1.61 2.38l-2.57 1.48c-.58.34-1.17.51-1.71.51m.01-7.24c-.16 0-.3.03-.41.1-.32.19-.51.66-.51 1.29v2.96c0 .63.18 1.1.51 1.29.32.19.82.11 1.37-.21l2.57-1.48c.55-.32.86-.71.86-1.08s-.31-.77-.86-1.08l-2.57-1.48c-.36-.21-.69-.31-.96-.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75m0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75"
  })));
};
export default SvgPlayBlue;